import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Layout, LoadingScreen, StatusPill } from '../components/Layout';
import { api } from '../lib/api';
import type { Appointment } from '../lib/types';

export function AppointmentListPage() {
  const list = useQuery({
    queryKey: ['appointments'],
    queryFn: () => api<{ data: Appointment[] }>('/api/appointments?limit=50').then((r) => r.data),
  });
  if (list.isLoading) return <Layout title="รายการใบนัด"><LoadingScreen /></Layout>;
  return (
    <Layout title="รายการใบนัด">
      <div className="mb-5 flex items-center justify-between">
        <p className="text-sm text-slate-500">{list.data?.length ?? 0} รายการ</p>
        <Link className="btn-primary" to="/capture">+ เพิ่มใบนัด</Link>
      </div>
      <section className="space-y-3">
        {list.data?.map((item) => (
          <Link key={item.id} to={`/appointments/${item.id}`} className="card flex items-center justify-between gap-3 transition hover:border-teal-300">
            <div className="min-w-0">
              <h2 className="truncate font-semibold">{item.title ?? 'ใบนัดใหม่'}</h2>
              <p className="mt-1 text-sm text-slate-600">{item.appointmentDate ?? 'ยังไม่ระบุวันที่'} {item.startTime ?? ''}</p>
              <p className="truncate text-sm text-slate-500">{item.organization ?? item.location ?? 'ยังไม่ระบุสถานที่'}</p>
            </div>
            <StatusPill status={item.status} />
          </Link>
        ))}
        {!list.data?.length && <div className="card py-10 text-center text-slate-500">ยังไม่มีรายการ เริ่มด้วยการเพิ่มไฟล์เอกสารของคุณ</div>}
      </section>
    </Layout>
  );
}
